export const BASEPATH = '/';
export const LOGINPATH = '/login';
export const USERMANAGEMENTPATH = '/user-management';
export const FACILITYMANAGEMENTPATH = '/facility-management';
export const EVENTMANAGEMENTPATH = '/event-management';
export const EVENTCREATIONPATH = '/event-creation';
export const BOOKINGSPATH = '/bookings';
export const SPORTSMANAGEMENTPATH = '/sports-management';
export const DOUBLESPLAYERDETAILSPATH = 'tournament/:tournamentId/players';
export const SINGLESBRACKETSPATH = 'tournament/:tournamentId/singles-brackets';
export const DOUBLESBRACKETSPATH = 'tournament/:tournamentId/doubles-brackets';
export const SINGLESGENERATEBRACKETPATH =
  'tournament/:tournamentId/single/generate-bracket';
export const TEAMSPLAYERSDETAILSPATH = 'tournament/:tournamentId/team-players';
export const TRANSACTIONSPATH = '/transactions';
export const MATCHSCOREPATH =
  '/event-management/:eventId/tournament/:tournamentId/singles-brackets/match/:matchId/score';

export const buildDoublesBracketsPath = (tournamentId: number): string =>
  `tournament/${tournamentId}/doubles-brackets`;

export const buildSinglesBracketsPath = (tournamentId: number): string =>
  `tournament/${tournamentId}/singles-brackets`;

export const buildDoublesPlayersDetailsPath = (tournamentId: number): string =>
  `tournament/${tournamentId}/players`;

export const buildSinglesGenerateBracketPath = (tournamentId: number): string =>
  `tournament/${tournamentId}/single/generate-bracket`;

export const buildTeamsPlayersDetailsPath = (tournamentId: number): string =>
  `tournament/${tournamentId}/team-players`;

export const buildMatchScorePath = (
  eventId: number,
  tournamentId: number,
  matchId: number,
): string =>
  `/event-management/${eventId}/tournament/${tournamentId}/singles-brackets/match/${matchId}/score`;
